import { render } from "./buttonSwitchLanguage.vue?vue&type=template&id=65d34e19&scoped=true"
import script from "./buttonSwitchLanguage.vue?vue&type=script&lang=js"
export * from "./buttonSwitchLanguage.vue?vue&type=script&lang=js"

import "./buttonSwitchLanguage.vue?vue&type=style&index=0&id=65d34e19&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65d34e19"]])

export default __exports__